<div fxLayout="row" class="header layout-presecure" data-test-id="hdContainer">
  <div
    fxFlex="100%"
    fxLayoutAlign="start center"
    data-test-id="hdLogoContainer"
    class="logo-container"
  >
    <cigna-header-logo
      [enableToggleSidNav]="true"
      [isFromLogin]="true"
      [attr.data-test-id]="'hdLogoConmponent'"
    ></cigna-header-logo>
  </div>
</div>

<div class="imp-main-section-wrapper">
  <router-outlet></router-outlet>
</div>

<cigna-cafooter-secure
  [isDivestEnabled]="isDivestEnabled"
></cigna-cafooter-secure>
